import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShading025 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 404,
	height: 116,
	viewBox: "0 0 404 116",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", { children: ".B{fill:#60c695}.C{fill:#7c6924}.D{fill:#ffad4c}.E{fill-rule:evenodd}.F{fill:#2c3f81}" }),
		/* @__PURE__ */ _jsxs("g", {
			stroke: "#2c3f81",
			strokeWidth: 3,
			children: [
				/* @__PURE__ */ _jsx("use", { href: "#E" }),
				/* @__PURE__ */ _jsx("use", {
					href: "#E",
					x: 120
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#E",
					x: 240
				}),
				/* @__PURE__ */ _jsxs("g", {
					strokeLinecap: "round",
					children: [/* @__PURE__ */ _jsx("path", { d: "M136.989 18h-104m223 0h-104m226 0h-104m-189 18v72" }), /* @__PURE__ */ _jsx("path", { d: "M84.989 3v28m120-28v28m121-28v28m-121 5v72m120-72v72" })]
				})
			]
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "A",
			maskUnits: "userSpaceOnUse",
			x: 72.989,
			y: 32,
			width: 24,
			height: 14,
			fill: "#000",
			children: [/* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M72.989 32h24v14h-24z"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M76.989 35c.109 4.325 3.649 7.797 8 7.797s7.891-3.473 8-7.797h-16z",
				className: "E"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.989 35v-3h-3.076l.077 3.075L76.989 35zm16 0l2.999.075.077-3.075h-3.076v3zm-8 4.797c-2.72 0-4.933-2.171-5.001-4.873l-5.998.151c.15 5.948 5.016 10.722 10.999 10.722v-6zm5.001-4.873c-.068 2.702-2.281 4.873-5.001 4.873v6c5.983 0 10.849-4.774 10.999-10.722l-5.998-.151zM92.989 32h-16v6h16v-6z",
			mask: "url(#A)",
			className: "F"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "B",
			maskUnits: "userSpaceOnUse",
			x: 192.989,
			y: 32,
			width: 24,
			height: 14,
			fill: "#000",
			children: [/* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M192.989 32h24v14h-24z"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M196.989 35c.109 4.325 3.649 7.797 8 7.797s7.891-3.473 8-7.797h-16z",
				className: "E"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M196.989 35v-3h-3.076l.077 3.075 2.999-.075zm16 0l2.999.075.078-3.075h-3.077v3zm-8 4.797c-2.719 0-4.933-2.171-5.001-4.873l-5.998.151c.15 5.948 5.017 10.722 10.999 10.722v-6zm5.001-4.873c-.068 2.702-2.281 4.873-5.001 4.873v6c5.983 0 10.85-4.774 10.999-10.722l-5.998-.151zM212.989 32h-16v6h16v-6z",
			mask: "url(#B)",
			className: "F"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "C",
			maskUnits: "userSpaceOnUse",
			x: 312.989,
			y: 32,
			width: 24,
			height: 14,
			fill: "#000",
			children: [/* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M312.989 32h24v14h-24z"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M316.989 35c.109 4.325 3.649 7.797 8 7.797s7.891-3.473 8-7.797h-16z",
				className: "E"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M316.989 35v-3h-3.076l.077 3.075 2.999-.075zm16 0l2.999.075.078-3.075h-3.077v3zm-8 4.797c-2.719 0-4.933-2.171-5.001-4.873l-5.998.151c.15 5.948 5.017 10.722 10.999 10.722v-6zm5.001-4.873c-.068 2.702-2.281 4.873-5.001 4.873v6c5.983 0 10.85-4.774 10.999-10.722l-5.998-.151zM332.989 32h-16v6h16v-6z",
			mask: "url(#C)",
			className: "F"
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#F",
			className: "B"
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#G",
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 143.971,
					cy: 90.866,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 151.34,
					cy: 89.077,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 148.577,
					cy: 95.339,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 157.789,
					cy: 94.444,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 152.262,
					cy: 81.92,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 157.789,
					cy: 87.288,
					rx: 1.382,
					ry: 1.342
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("use", { href: "#H" }),
				/* @__PURE__ */ _jsx("use", { href: "#I" }),
				/* @__PURE__ */ _jsx("use", { href: "#J" }),
				/* @__PURE__ */ _jsx("use", { href: "#K" })
			]
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#G",
			x: -99,
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 44.971,
					cy: 90.866,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 52.34,
					cy: 89.077,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 49.577,
					cy: 95.339,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 58.789,
					cy: 94.444,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 53.262,
					cy: 81.92,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 58.789,
					cy: 87.288,
					rx: 1.382,
					ry: 1.342
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "M42.746 106.147c.005.019.007.04.018.056.191.287.281.611.37.93.226.8.357 1.617.468 2.437.026.194-.015.175.213.178h.181l2.297.004c.098 0 .138-.018.158-.11l.468-2.163c.126-.444.257-.887.454-1.31.035-.074.084-.142.126-.213l-.023-.015c-.374.352-.717.728-1.008 1.143a7.7 7.7 0 0 0-.745 1.3c-.023-.718.062-1.424.148-2.129s.256-1.393.512-2.064c-1.182 1.303-1.784 2.813-1.917 4.502-.349-.979-.95-1.808-1.721-2.546zm9.042-.214c-.805.674-1.39 1.491-1.807 2.418-.284-1.262-.919-2.344-1.873-3.273 0 .032.014.058.026.084.054.122.128.239.157.365l.256 1.242.189 2.846v.108c.03.007.045.014.059.014l1.89.007c.024 0 .064-.042.068-.068l.366-1.823c.161-.655.318-1.315.667-1.92h.002zm1.202 1.344c-.858.672-1.46 1.456-1.703 2.466l1.07-.004c.025 0 .067-.051.071-.082l.091-.73.258-1.166c.041-.157.132-.304.213-.484zm-11.454.246c.096.203.203.384.266.577.168.516.306 1.04.343 1.581.004.052.019.072.08.072l.827-.007c.032 0 .064-.005.114-.009-.32-.884-.881-1.598-1.629-2.213v-.001zm6.497.184c-.667.553-1.124 1.218-1.342 2.032l.141.007.769.003c.097.003.12-.028.122-.109l.04-.912c.016-.273.044-.545.157-.803.033-.074.075-.145.113-.218z" }),
				/* @__PURE__ */ _jsx("path", { d: "M50.382 106.147c.005.019.007.04.018.056.191.287.281.611.37.93.226.8.357 1.617.467 2.437.026.194-.016.175.213.178h.181l2.297.004c.098 0 .138-.018.159-.11l.468-2.163c.126-.444.257-.887.454-1.31.035-.074.084-.142.126-.213l-.023-.015c-.374.352-.717.728-1.008 1.143s-.542.843-.745 1.3c-.023-.718.062-1.424.148-2.129a8.73 8.73 0 0 1 .512-2.064c-1.182 1.303-1.784 2.813-1.917 4.502-.349-.979-.95-1.808-1.72-2.546zm9.042-.214c-.805.674-1.39 1.491-1.807 2.418-.284-1.262-.919-2.344-1.873-3.273 0 .032.014.058.026.084.054.122.128.239.157.365l.256 1.242.189 2.846v.108c.03.007.045.014.059.014l1.89.007c.024 0 .064-.042.068-.068l.366-1.823c.161-.655.318-1.315.667-1.92h.002zm1.202 1.344c-.858.672-1.46 1.456-1.703 2.466l1.07-.004c.025 0 .066-.051.071-.082l.091-.73.258-1.166c.041-.157.132-.304.213-.484zm-11.454.246c.096.203.203.384.266.577.168.516.306 1.04.343 1.581.004.052.019.072.08.072l.827-.007c.032 0 .064-.005.114-.009-.32-.884-.881-1.598-1.629-2.213v-.001zm6.497.184c-.667.553-1.124 1.218-1.342 2.032l.141.007.769.003c.098.003.12-.028.122-.109l.04-.912c.015-.273.044-.545.157-.803.033-.074.075-.145.113-.218z" }),
				/* @__PURE__ */ _jsx("path", { d: "M54.2 106.147c.006.019.007.04.018.056.191.287.281.611.37.93.226.8.357 1.617.467 2.437.026.194-.015.175.213.178h.181l2.297.004c.098 0 .138-.018.158-.11l.468-2.163c.126-.444.257-.887.454-1.31.035-.074.084-.142.126-.213l-.023-.015c-.375.352-.717.728-1.008 1.143a7.7 7.7 0 0 0-.745 1.3c-.023-.718.062-1.424.148-2.129a8.73 8.73 0 0 1 .512-2.064c-1.182 1.303-1.784 2.813-1.917 4.502-.349-.979-.95-1.808-1.721-2.546zm9.042-.214c-.805.674-1.39 1.491-1.807 2.418-.284-1.262-.919-2.344-1.873-3.273 0 .032.014.058.026.084.054.122.128.239.157.365l.256 1.242.189 2.846v.108c.03.007.045.014.059.014l1.89.007c.024 0 .064-.042.068-.068l.366-1.823c.161-.655.318-1.315.667-1.92h.002zm1.202 1.344c-.858.672-1.46 1.456-1.703 2.466l1.07-.004c.025 0 .067-.051.071-.082l.091-.73.258-1.166c.041-.157.132-.304.213-.484zm-11.454.246c.096.203.203.384.266.577.168.516.306 1.04.343 1.581.004.052.019.072.08.072l.827-.007c.032 0 .064-.005.114-.009-.32-.884-.881-1.598-1.629-2.213v-.001zm6.497.184c-.667.553-1.123 1.218-1.342 2.032l.141.007.769.003c.097.003.12-.028.122-.109l.04-.912c.016-.273.044-.545.157-.803.033-.074.075-.145.113-.218z" }),
				/* @__PURE__ */ _jsx("use", {
					href: "#F",
					x: 33
				})
			]
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#G",
			x: 33,
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 176.971,
					cy: 90.866,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 184.34,
					cy: 89.077,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 181.577,
					cy: 95.339,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 190.789,
					cy: 94.444,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 185.262,
					cy: 81.92,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 190.789,
					cy: 87.288,
					rx: 1.382,
					ry: 1.342
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("use", {
					href: "#H",
					x: 33
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#I",
					x: 33
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#J",
					x: 33
				}),
				/* @__PURE__ */ _jsx("path", { d: "M75.021 109.839l9.617-.395v-8.762l-3.906-.026c-2.401-.015-4.442-.85-6.124-2.505s-2.514-3.648-2.498-5.98a8.17 8.17 0 0 1 1.464-4.647c.965-1.413 2.259-2.437 3.884-3.072.275-2.105 1.235-3.862 2.879-5.27s3.566-2.105 5.765-2.091 4.111.736 5.735 2.166 2.56 3.199 2.806 5.307c1.616.657 2.896 1.698 3.841 3.123s1.412 2.98 1.4 4.666c-.016 2.332-.876 4.314-2.58 5.947s-3.756 2.441-6.158 2.425l-3.906-.025v8.788l10.063-.043-.152.539-22.132-.144z" })
			]
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#G",
			x: -65.999,
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 77.971,
					cy: 90.866,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 85.34,
					cy: 89.077,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 82.577,
					cy: 95.339,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 91.789,
					cy: 94.444,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 86.262,
					cy: 81.92,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 91.789,
					cy: 87.288,
					rx: 1.382,
					ry: 1.342
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "M75.746 106.147c.005.019.007.04.018.056.191.287.281.611.37.93.226.8.357 1.617.468 2.437.026.194-.016.175.213.178h.181l2.297.004c.098 0 .138-.018.159-.11l.468-2.163c.126-.444.257-.887.454-1.31.035-.074.084-.142.126-.213l-.023-.015c-.374.352-.717.728-1.008 1.143a7.7 7.7 0 0 0-.745 1.3c-.023-.718.062-1.424.148-2.129s.256-1.393.512-2.064c-1.182 1.303-1.784 2.813-1.917 4.502-.349-.979-.951-1.808-1.721-2.546zm9.042-.214c-.805.674-1.39 1.491-1.807 2.418-.284-1.262-.918-2.344-1.873-3.273 0 .032.014.058.025.084.054.122.128.239.157.365l.256 1.242.189 2.846v.108c.03.007.045.014.059.014l1.89.007c.024 0 .064-.042.068-.068l.366-1.823c.161-.655.318-1.315.667-1.92h.002zm1.202 1.344c-.858.672-1.46 1.456-1.703 2.466l1.07-.004c.025 0 .066-.051.071-.082l.091-.73.258-1.166c.041-.157.132-.304.213-.484zm-11.454.246c.096.203.203.384.266.577.168.516.306 1.04.343 1.581.004.052.019.072.08.072l.826-.007c.032 0 .064-.005.114-.009-.32-.884-.881-1.598-1.629-2.213v-.001zm6.497.184c-.667.553-1.124 1.218-1.342 2.032l.141.007.769.003c.098.003.12-.028.122-.109l.04-.912c.015-.273.044-.545.157-.803.033-.074.075-.145.113-.218z" }),
				/* @__PURE__ */ _jsx("path", { d: "M83.382 106.147c.005.019.007.04.018.056.191.287.281.611.37.93.226.8.357 1.617.467 2.437.026.194-.016.175.213.178h.181l2.297.004c.098 0 .138-.018.159-.11l.468-2.163c.126-.444.257-.887.454-1.31.035-.074.084-.142.126-.213l-.023-.015c-.375.352-.717.728-1.008 1.143s-.542.843-.745 1.3c-.023-.718.062-1.424.148-2.129a8.73 8.73 0 0 1 .512-2.064c-1.182 1.303-1.784 2.813-1.917 4.502-.349-.979-.95-1.808-1.72-2.546zm9.042-.214c-.805.674-1.39 1.491-1.807 2.418-.284-1.262-.919-2.344-1.873-3.273 0 .032.014.058.026.084.054.122.128.239.157.365l.256 1.242.189 2.846v.108c.03.007.045.014.059.014l1.89.007c.024 0 .064-.042.068-.068l.366-1.823c.161-.655.318-1.315.667-1.92h.002zm1.202 1.344c-.858.672-1.46 1.456-1.703 2.466l1.07-.004c.025 0 .067-.051.071-.082l.091-.73.258-1.166c.041-.157.132-.304.213-.484zm-11.454.246c.096.203.203.384.266.577.168.516.306 1.04.343 1.581.004.052.019.072.08.072l.826-.007c.032 0 .064-.005.114-.009-.32-.884-.881-1.598-1.629-2.213v-.001zm6.497.184c-.667.553-1.124 1.218-1.342 2.032l.141.007.769.003c.098.003.12-.028.122-.109l.04-.912c.015-.273.044-.545.157-.803.033-.074.075-.145.113-.218z" }),
				/* @__PURE__ */ _jsx("path", { d: "M87.2 106.147c.005.019.007.04.018.056.191.287.281.611.37.93.226.8.357 1.617.468 2.437.026.194-.016.175.213.178h.181l2.297.004c.098 0 .138-.018.159-.11l.468-2.163c.126-.444.257-.887.454-1.31.035-.074.084-.142.126-.213l-.023-.015c-.374.352-.717.728-1.008 1.143a7.7 7.7 0 0 0-.745 1.3c-.023-.718.062-1.424.148-2.129a8.73 8.73 0 0 1 .512-2.064c-1.182 1.303-1.784 2.813-1.917 4.502-.349-.979-.951-1.808-1.721-2.546zm9.042-.214c-.805.674-1.39 1.491-1.807 2.418-.284-1.262-.918-2.344-1.873-3.273 0 .032.014.058.025.084.054.122.128.239.157.365l.256 1.242.189 2.846v.108c.03.007.045.014.059.014l1.89.007c.024 0 .064-.042.068-.068l.366-1.823c.161-.655.318-1.315.667-1.92h.002zm1.202 1.344c-.858.672-1.46 1.456-1.703 2.466l1.07-.004c.025 0 .066-.051.071-.082l.091-.73.258-1.166c.041-.157.132-.304.213-.484zm-11.454.246c.096.203.203.384.266.577.168.516.306 1.04.343 1.581.004.052.019.072.08.072l.826-.007c.032 0 .064-.005.114-.009-.32-.884-.881-1.598-1.629-2.213v-.001zm6.497.184c-.667.553-1.124 1.218-1.342 2.032l.141.007.769.003c.098.003.12-.028.122-.109l.04-.912c.015-.273.044-.545.157-.803.033-.074.075-.145.113-.218z" }),
				/* @__PURE__ */ _jsx("use", {
					href: "#F",
					x: 66
				})
			]
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#G",
			x: 66,
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 209.971,
					cy: 90.866,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 217.34,
					cy: 89.077,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 214.577,
					cy: 95.339,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 223.789,
					cy: 94.444,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 218.262,
					cy: 81.92,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 223.789,
					cy: 87.288,
					rx: 1.382,
					ry: 1.342
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("use", {
					href: "#H",
					x: 66
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#I",
					x: 66
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#J",
					x: 66
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#F",
					x: -33
				})
			]
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#G",
			x: -33,
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 110.971,
					cy: 90.866,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 118.34,
					cy: 89.077,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 115.577,
					cy: 95.339,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 124.789,
					cy: 94.444,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 119.262,
					cy: 81.92,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 124.789,
					cy: 87.288,
					rx: 1.382,
					ry: 1.342
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("use", {
					href: "#H",
					x: -33
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#I",
					x: -33
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#J",
					x: -33
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#F",
					x: 99
				})
			]
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#G",
			x: 99,
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 242.971,
					cy: 90.866,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 250.34,
					cy: 89.077,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 247.577,
					cy: 95.339,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 256.789,
					cy: 94.444,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 251.262,
					cy: 81.92,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 256.789,
					cy: 87.288,
					rx: 1.382,
					ry: 1.342
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("use", {
					href: "#H",
					x: 99
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#I",
					x: 99
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#J",
					x: 99
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#F",
					x: 132
				})
			]
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#G",
			x: 132,
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 275.971,
					cy: 90.866,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 283.34,
					cy: 89.077,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 280.577,
					cy: 95.339,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 289.789,
					cy: 94.444,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 284.262,
					cy: 81.92,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 289.789,
					cy: 87.288,
					rx: 1.382,
					ry: 1.342
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("use", {
					href: "#H",
					x: 132
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#I",
					x: 132
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#J",
					x: 132
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#F",
					x: 165
				})
			]
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#G",
			x: 165,
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 308.971,
					cy: 90.866,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 316.34,
					cy: 89.077,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 313.577,
					cy: 95.339,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 322.789,
					cy: 94.444,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 317.262,
					cy: 81.92,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 322.789,
					cy: 87.288,
					rx: 1.382,
					ry: 1.342
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("use", {
					href: "#H",
					x: 165
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#I",
					x: 165
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#J",
					x: 165
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#F",
					x: 198
				})
			]
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#G",
			x: 198,
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 341.971,
					cy: 90.866,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 349.34,
					cy: 89.077,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 346.577,
					cy: 95.339,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 355.789,
					cy: 94.444,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 350.262,
					cy: 81.92,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 355.789,
					cy: 87.288,
					rx: 1.382,
					ry: 1.342
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("use", {
					href: "#H",
					x: 198
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#I",
					x: 198
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#J",
					x: 198
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#F",
					x: 231
				})
			]
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#G",
			x: 231,
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 374.971,
					cy: 90.866,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 382.34,
					cy: 89.077,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 379.577,
					cy: 95.339,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 388.789,
					cy: 94.444,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 383.262,
					cy: 81.92,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 388.789,
					cy: 87.288,
					rx: 1.382,
					ry: 1.342
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("use", {
					href: "#H",
					x: 231
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#I",
					x: 231
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#J",
					x: 231
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#K",
					x: -33
				})
			]
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#G",
			x: -132,
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 11.971,
					cy: 90.866,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 19.34,
					cy: 89.077,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 16.577,
					cy: 95.339,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 25.789,
					cy: 94.444,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 20.262,
					cy: 81.92,
					rx: 1.382,
					ry: 1.342
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 25.789,
					cy: 87.288,
					rx: 1.382,
					ry: 1.342
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "M9.746 106.147c.005.019.007.04.018.056.191.287.281.611.37.93.226.8.357 1.617.467 2.437.026.194-.015.175.213.178h.181l2.297.004c.098 0 .138-.018.159-.11l.468-2.163c.126-.444.257-.887.454-1.31.035-.074.084-.142.126-.213l-.023-.015c-.375.352-.717.728-1.008 1.143a7.7 7.7 0 0 0-.745 1.3c-.023-.718.062-1.424.148-2.129s.256-1.393.512-2.064c-1.182 1.303-1.784 2.813-1.917 4.502-.349-.979-.95-1.808-1.72-2.546zm9.042-.214c-.805.674-1.39 1.491-1.807 2.418-.284-1.262-.919-2.344-1.873-3.273 0 .032.014.058.026.084.054.122.128.239.157.365l.256 1.242.189 2.846v.108c.03.007.045.014.059.014l1.89.007c.024 0 .064-.042.068-.068l.366-1.823c.161-.655.318-1.315.667-1.92h.002zm1.202 1.344c-.858.672-1.46 1.456-1.703 2.466l1.07-.004c.025 0 .067-.051.071-.082l.091-.73.258-1.166c.041-.157.132-.304.213-.484zm-11.455.246c.096.203.203.384.266.577.168.516.306 1.04.343 1.581.004.052.019.072.08.072l.827-.007c.032 0 .064-.005.114-.009-.32-.884-.881-1.598-1.629-2.213v-.001zm6.497.184c-.667.553-1.124 1.218-1.342 2.032l.141.007.769.003c.098.003.12-.028.122-.109l.04-.912c.015-.273.044-.545.157-.803.033-.074.075-.145.113-.218z" }),
				/* @__PURE__ */ _jsx("path", { d: "M17.382 106.147c.005.019.007.04.018.056.191.287.281.611.37.93.226.8.357 1.617.467 2.437.026.194-.015.175.213.178h.181l2.297.004c.098 0 .138-.018.159-.11l.468-2.163c.126-.444.257-.887.454-1.31.035-.074.084-.142.126-.213l-.023-.015c-.374.352-.717.728-1.008 1.143s-.542.843-.745 1.3c-.023-.718.062-1.424.148-2.129a8.73 8.73 0 0 1 .512-2.064c-1.182 1.303-1.784 2.813-1.917 4.502-.349-.979-.95-1.808-1.72-2.546zm9.042-.214c-.805.674-1.39 1.491-1.807 2.418-.284-1.262-.919-2.344-1.873-3.273 0 .032.014.058.026.084.054.122.128.239.157.365l.256 1.242.189 2.846v.108c.03.007.045.014.059.014l1.89.007c.024 0 .064-.042.068-.068l.366-1.823c.161-.655.318-1.315.667-1.92h.002zm1.202 1.344c-.858.672-1.46 1.456-1.703 2.466l1.07-.004c.025 0 .066-.051.071-.082l.091-.73.258-1.166c.041-.157.132-.304.213-.484zm-11.454.246c.096.203.203.384.266.577.168.516.306 1.04.343 1.581.004.052.019.072.08.072l.826-.007c.032 0 .064-.005.114-.009-.32-.884-.881-1.598-1.629-2.213v-.001zm6.497.184c-.667.553-1.124 1.218-1.342 2.032l.141.007.769.003c.098.003.12-.028.122-.109l.04-.912c.015-.273.044-.545.157-.803.033-.074.075-.145.113-.218z" }),
				/* @__PURE__ */ _jsx("path", { d: "M21.2 106.147c.006.019.007.04.018.056.191.287.281.611.37.93.226.8.357 1.617.468 2.437.026.194-.015.175.213.178h.181l2.297.004c.098 0 .138-.018.159-.11l.468-2.163c.126-.444.257-.887.454-1.31.035-.074.084-.142.126-.213l-.023-.015c-.375.352-.717.728-1.008 1.143a7.7 7.7 0 0 0-.745 1.3c-.023-.718.062-1.424.148-2.129a8.73 8.73 0 0 1 .512-2.064c-1.182 1.303-1.784 2.813-1.917 4.502-.349-.979-.95-1.808-1.721-2.546zm9.042-.214c-.805.674-1.39 1.491-1.807 2.418-.284-1.262-.918-2.344-1.873-3.273 0 .032.014.058.026.084.054.122.128.239.157.365l.256 1.242.189 2.846v.108c.03.007.045.014.059.014l1.89.007c.024 0 .064-.042.068-.068l.366-1.823c.161-.655.318-1.315.667-1.92h.002zm1.202 1.344c-.858.672-1.46 1.456-1.703 2.466l1.07-.004c.025 0 .066-.051.071-.082l.091-.73.258-1.166c.041-.157.132-.304.213-.484zm-11.454.246c.096.203.203.384.266.577.168.516.306 1.04.343 1.581.004.052.019.072.08.072l.826-.007c.032 0 .064-.005.114-.009-.32-.884-.881-1.598-1.629-2.213v-.001zm6.497.184c-.667.553-1.123 1.218-1.342 2.032l.141.007.769.003c.098.003.12-.028.122-.109l.04-.912c.015-.273.044-.545.157-.803.033-.074.075-.145.113-.218z" })
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("path", {
				id: "E",
				d: "M34.989 1.5a4.5 4.5 0 0 0-4.5 4.5v23a4.5 4.5 0 0 0 4.5 4.5h99a4.5 4.5 0 0 0 4.5-4.5V6a4.5 4.5 0 0 0-4.5-4.5h-99z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "F",
				d: "M141.021 109.839l9.617-.395v-8.762l-3.906-.026c-2.401-.015-4.442-.85-6.124-2.505s-2.513-3.648-2.497-5.98c.011-1.686.499-3.235 1.464-4.647s2.259-2.437 3.884-3.072c.275-2.105 1.234-3.862 2.879-5.27s3.565-2.105 5.764-2.091a8.49 8.49 0 0 1 5.736 2.166c1.624 1.429 2.56 3.199 2.806 5.307 1.615.657 2.896 1.698 3.841 3.123a8.17 8.17 0 0 1 1.4 4.666c-.016 2.332-.876 4.314-2.58 5.947s-3.756 2.441-6.158 2.425l-3.905-.025v8.788l10.063-.043-.152.539-22.132-.144z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "G",
				d: "M149.958 100.259h3.685v8.051h-3.685z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "H",
				d: "M141.746 106.147c.005.019.007.04.018.056.191.287.281.611.37.93.226.8.357 1.617.467 2.437.027.194-.015.175.214.178h.181l2.297.004c.099 0 .138-.018.159-.11l.468-2.163c.126-.444.257-.887.454-1.31.035-.074.084-.142.126-.213l-.023-.015c-.375.352-.717.728-1.008 1.143s-.542.843-.745 1.3c-.023-.718.062-1.424.147-2.129a8.75 8.75 0 0 1 .512-2.064c-1.181 1.303-1.784 2.813-1.917 4.502-.349-.979-.95-1.808-1.72-2.546zm9.041-.214c-.804.674-1.389 1.491-1.807 2.418-.284-1.262-.918-2.344-1.872-3.273 0 .032.013.058.025.084.054.122.128.239.157.365l.256 1.242.189 2.846v.108c.03.007.044.014.059.014l1.89.007c.023 0 .064-.042.068-.068l.366-1.823c.162-.655.318-1.315.667-1.92h.002zm1.202 1.344c-.858.672-1.46 1.456-1.703 2.466l1.07-.004c.024 0 .066-.051.071-.082l.091-.73.258-1.166c.041-.157.132-.304.213-.484zm-11.454.246c.095.203.203.384.266.577.167.516.306 1.04.342 1.581.004.052.02.072.081.072l.826-.007c.032 0 .064-.005.114-.009-.32-.884-.881-1.598-1.629-2.213v-.001zm6.497.184c-.667.553-1.124 1.218-1.342 2.032l.141.007.769.003c.098.003.12-.028.122-.109l.04-.912c.016-.273.044-.545.157-.803.033-.074.075-.145.113-.218z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "I",
				d: "M149.382 106.147c.005.019.007.04.018.056.192.287.281.611.37.93.226.8.357 1.617.468 2.437.026.194-.016.175.213.178h.181l2.298.004c.098 0 .137-.018.158-.11l.468-2.163c.126-.444.257-.887.454-1.31.035-.074.084-.142.126-.213l-.023-.015a7.47 7.47 0 0 0-1.008 1.143c-.289.412-.542.843-.745 1.3-.023-.718.062-1.424.148-2.129a8.7 8.7 0 0 1 .512-2.064c-1.182 1.303-1.785 2.813-1.918 4.502-.349-.979-.95-1.808-1.72-2.546zm9.041-.214c-.804.674-1.389 1.491-1.807 2.418-.284-1.262-.918-2.344-1.872-3.273 0 .032.013.058.025.084.054.122.128.239.157.365l.256 1.242.189 2.846v.108c.03.007.044.014.059.014l1.89.007c.024 0 .064-.042.068-.068l.367-1.823c.161-.655.318-1.315.667-1.92h.001zm1.202 1.344c-.858.672-1.459 1.456-1.703 2.466l1.07-.004c.025 0 .067-.051.071-.082l.091-.73.258-1.166c.041-.157.132-.304.213-.484zm-11.454.246c.096.203.203.384.266.577.168.516.306 1.04.343 1.581.003.052.019.072.08.072l.826-.007c.032 0 .064-.005.114-.009-.32-.884-.881-1.598-1.629-2.213v-.001zm6.497.184c-.667.553-1.123 1.218-1.342 2.032l.141.007.769.003c.098.003.121-.028.122-.109l.04-.912c.016-.273.044-.545.157-.803.033-.074.075-.145.113-.218z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "J",
				d: "M153.2 106.147c.006.019.008.04.019.056.191.287.28.611.37.93.226.8.357 1.617.467 2.437.026.194-.015.175.213.178h.182l2.297.004c.098 0 .137-.018.158-.11l.469-2.163c.126-.444.257-.887.454-1.31.034-.074.083-.142.125-.213l-.022-.015c-.375.352-.718.728-1.008 1.143a7.74 7.74 0 0 0-.746 1.3c-.022-.718.062-1.424.148-2.129a8.75 8.75 0 0 1 .512-2.064c-1.182 1.303-1.784 2.813-1.917 4.502-.349-.979-.951-1.808-1.721-2.546zm9.042-.214c-.805.674-1.39 1.491-1.807 2.418-.284-1.262-.919-2.344-1.873-3.273 0 .032.014.058.026.084.053.122.127.239.156.365l.256 1.242.189 2.846v.108c.03.007.045.014.059.014l1.89.007c.024 0 .064-.042.069-.068l.366-1.823c.161-.655.318-1.315.667-1.92h.002zm1.202 1.344c-.859.672-1.46 1.456-1.703 2.466l1.069-.004c.025 0 .067-.051.072-.082l.091-.73.258-1.166c.041-.157.132-.304.213-.484zm-11.455.246c.096.203.203.384.266.577.168.516.307 1.04.343 1.581.004.052.019.072.08.072l.827-.007c.032 0 .063-.005.114-.009-.32-.884-.882-1.598-1.63-2.213v-.001zm6.498.184c-.667.553-1.124 1.218-1.343 2.032l.142.007.769.003c.097.003.12-.028.122-.109l.04-.912c.015-.273.044-.545.157-.803.032-.074.074-.145.113-.218z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "K",
				d: "M42.021 109.839l9.617-.395v-8.762l-3.906-.026c-2.401-.015-4.442-.85-6.124-2.505s-2.514-3.648-2.498-5.98a8.17 8.17 0 0 1 1.464-4.647c.964-1.413 2.259-2.437 3.884-3.072.275-2.105 1.235-3.862 2.879-5.27s3.566-2.105 5.765-2.091 4.111.736 5.735 2.166 2.56 3.199 2.806 5.307c1.616.657 2.896 1.698 3.841 3.123s1.412 2.98 1.4 4.666c-.016 2.332-.876 4.314-2.58 5.947s-3.756 2.441-6.158 2.425l-3.906-.025v8.788l10.063-.043-.152.539-22.132-.144z"
			})
		] })
	]
});
export default SvgShading025;
